import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const DeleteMeetingIcon: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.36719 18C1.97656 18 1.64453 17.8542 1.37109 17.5625C1.09766 17.2708 0.960938 16.9167 0.960938 16.5V2.25H0V0.75H4.40625V0H10.5938V0.75H15V2.25H14.0391V16.5C14.0391 16.9 13.8984 17.25 13.6172 17.55C13.3359 17.85 13.0078 18 12.6328 18H2.36719ZM12.6328 2.25H2.36719V16.5H12.6328V2.25ZM4.85156 14.35H6.25781V4.375H4.85156V14.35ZM8.74219 14.35H10.1484V4.375H8.74219V14.35ZM2.36719 2.25V16.5V2.25Z" fill="#434649" fillOpacity="0.85"/>
    </svg>
  </SvgWrapper>
);